import React from "react";
import { CarouselHP } from "../HumanPractices/CarouselHP";
import { CarouselBS } from "../BSGV/CarouselBS";
import { Link } from 'react-router-dom';


const ArticleEducation = () => {
  const gymvis = [
    {
      title: "Team presenting",
      icon: "https://static.igem.wiki/teams/4888/wiki/gymvis1.jpeg",
    },
    {
      title: "Team presenting",
      icon: "https://static.igem.wiki/teams/4888/wiki/gymvis2.jpeg",
    },
  ];

  const Mint = [
    {
      title: "Lab day",
      icon: "https://static.igem.wiki/teams/4888/wiki/mint.jpeg",
    },
  ];

  const BSGV = [
    {
      title: "BSGV presentation",
      icon: "https://static.igem.wiki/teams/4888/wiki/education/bsgv.png",
    },
    {
      title: "Team 1",
      icon: "https://static.igem.wiki/teams/4888/wiki/education/mucovisidose.png",
    },
    {
      title: "Team 2",
      icon: "https://static.igem.wiki/teams/4888/wiki/education/les-perturbaterus-endocriniens-dans-l-eau.jpg",
    },
  ];
  const wiki = [
    {
      title: "Description page",
      icon: "https://static.igem.wiki/teams/4888/wiki/friendlydescription.png",
    },
    {
      title: "Navigation bar",
      icon: "https://static.igem.wiki/teams/4888/wiki/user-friendly.png",
    },
  ];

  return (
    <div>
      <div id="introedu">
        <p className="mb-2">
          The magnitude of change achieved by scientists and engineers has
          always been related to its support in society. The lack of
          understanding by society’s members can cause those ideas to fall short
          of their potential. Implementing changes in society thus comes hand in
          hand with the education of its members. By raising awareness and
          fostering interest we can create a thirst for knowledge and aim for
          education to take its most interesting and effective form: “learning
          by doing”.
        </p>
        <p className="mb-2">
          In light of this perspective, we made the decision to carry out
          numerous initiatives meant to educate the public about synthetic
          biology and the issues it can help resolve, including this our
          problem: cadmium intoxication.
        </p>
        <p className="mb-2">
          If education needs to be implemented for every member of society, we
          nevertheless decided this year to focus on, but not restrict ourselves
          to educating younger students. By educating young people, we hope to
          spark their interest in synthetic biology and inspire them to use
          engineering to make the changes we want to see rather than be a
          spectator to them.
        </p>
        <p>
          Our initiatives were and carried out throughout our entire project. To
          reach the most people in the most effective way possible we decided to
          implement both initiatives with direct contact with the intended
          public and initiatives accessible to a broader public through
          intermediaries.
        </p>
      </div>
      <div>
        <h2 id="BSGV" className="mt-20">
          BSGV (Biologie Synthétique par les Gymnases Vaudois = Synthetic
          biology by Vaudois High school)
        </h2>
        <hr className="dividergeneral mb-5" />

        <p className="mb-2">
          In line with our commitment to promote hands-on education and foster a
          culture of "learning by doing," we have initiated the development of
          BSGV, a "mini-iGEM" competition designed specifically for high school
          students in our region.
        </p>
        <p>The primary objectives of this endeavor are as follows:</p>
        <ul
          className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}
        >
          <li>
            <mark>
              <b>Cultivate an Engineering Mindset: </b>
            </mark>
            Our foremost goal is to instil an engineering way of thinking in
            high school students before they embark on higher education. By
            engaging in synthetic biology projects, they gain early exposure to
            the problem-solving and innovation processes integral to engineering
            disciplines.
          </li>
          <li>
            <mark>
              <b>Application of Synthetic Biology Knowledge: </b>
            </mark>
            We aim to encourage students to learn and apply their acquired
            knowledge of synthetic biology. Participants are required to develop
            their own projects and articulate their ideas in written form, which
            deepens their understanding of the subject matter.
          </li>
          <li>
            <mark>
              <b>Effective Communication Skills: </b>
            </mark>
            To prepare students for potential careers in engineering, we
            challenge them to create posters and videos summarizing their
            projects. This not only helps them convey complex ideas effectively
            but also serves as a valuable skill set if they choose to pursue
            engineering studies.
          </li>
        </ul>

        <p>
          To support students throughout the 6-week project duration, we
          provided multiple forms of assistance:
        </p>
        <ul
          className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}
        >
          <li>
            <mark>
              <b>Educational Videos: </b>
            </mark>
            We created and recorded a set of educational videos covering
            synthetic biology and related subjects. These videos are accessible
            to all on the BSGV YouTube channel. The topics include introductions
            to synthetic biology, engineering principles in this field, the
            central dogma of biology, DNA, RNA, proteins, organisms used in
            synthetic biology, tools employed, safety measures, recent
            advancements, and real-world examples from iGEM projects. The videos
            were shared with the students to educate them on the basics of
            synthetic biology which in turn will help the development of their
            project.
          </li>
          <li>
            <mark>
              <b>Online Guidance and Support: </b>
            </mark>
            Our team members were available to answer any questions the students
            had during the entire project duration. This online support ensured
            that participants had the resources and guidance they needed to
            succeed.
          </li>
        </ul>
        <p className="mb-2">
          The competition is set to conclude at the end of November with an
          award ceremony scheduled to take place at EPFL. During this event,
          each project will be presented, and medals and prizes will be
          distributed to the participating students. Moreover, students will
          receive constructive feedback on their work, both through in-person
          discussions with the team members and in written form, providing a
          more profound analysis and insights into their project and the methods
          they employed.
        </p>
        <p className="mb-2">
          Our ultimate vision is to establish BSGV as an annual event that
          attracts a growing number of students. We have already garnered
          interest from multiple teachers and the DGEP (direction générale de
          l’enseignement post-obligatoire), suggesting a promising potential for
          future expansion and development. We are actively exploring
          opportunities to enhance and refine the program, to further foster
          students' passion for synthetic biology and engineering education.
        </p>
        <p className="mb-2">
          By continuing to organize the competition, our aim is to inspire the
          next generation of engineers and synthetic biologists. We also
          encourage other teams to focus on educational initiatives to help
          achieve this broader goal.
        </p>
        <p className="mb-2">
          More informations, as well as as our video courses and all of our
          competition's documentation is available to everyone on our dedicated{" "}
          <a href="../epfl/BSGV">BSGV page</a>.
        </p>
        <center>
        <Link to="../epfl/bsgv">
        <button
          style={{
            backgroundColor: '#e29aff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginLeft: '50px', // Augmentez la marge à droite
          }}
        >
          BSGV PAGE
        </button>
      </Link>
      </center>
      <br></br> 
        <p className="mb-2">
          The most outstanding projects for this year's edition can be found 
          right below. The english translation to the posters' texts is available on the 
          <a href="../epfl/BSGV"> BSGV page</a>.
        </p>

        <div className="centered-image">
          <CarouselBS items={BSGV} title="BSGV" />
        </div>
        


        <div>
          <h2 id="BQ" className="mt-20">
            BioQuest
          </h2>
          <hr className="dividergeneral mb-5" />

          <p className="mb-2">
            In the realm of education, face-to-face interactions and hands-on
            experiences undeniably enhance the learning process, which is why
            our first initiatives were of this nature. However, it is important
            to recognize that these methods limit access to education to only a
            fraction of the population.
          </p>
          <p className="mb-2">
            To address this limitation, we have decided to incorporate remote
            educational tools into our approach. The first outcome of this
            initiative is "BioQuest."
          </p>
          <p className="mb-2">
            Synthetic biology is a complex subject with educational initiative
            often being reserved for high school and beyond in educational
            programs. With BioQuest, our aim is to bridge this educational gap
            by making synthetic biology accessible to learners of all ages.
          </p>
          <p className="mb-2">
            BioQuest is an interactive game designed to introduce the
            fundamental principles of synthetic biology and delve into the world
            of some iGEM projects. This game comprises two main components: the
            main game and mini games.
          </p>
          <p className="mb-2">
            The main game revolves around the exploration of key concepts in
            synthetic biology, incorporated into the narrative of our project.
            Each level introduces a new concept, gradually building the player's
            understanding. As the game progresses, players are challenged to
            combine these concepts to overcome higher levels of difficulty.
            Furthermore, in collaboration with other teams, we had the
            opportunity to expand the game by introducing new levels based on
            novel concepts and other iGEM projects.
          </p>
          <p className="mb-2">
            Complementing the main game, BioQuest offers a selection of
            mini-games. These short, timed experiences enable players to delve
            into essential laboratory practices, such as laboratory techniques
            and lab safety. It provides an engaging hands-on experience within a
            virtual environment.
          </p>
          <p className="mb-2">
            BioQuest stands as an educational endeavor that strives to inform
            individuals of all ages about synthetic biology while simultaneously
            entertaining them. Our goal is to break down barriers to learning
            and foster a deeper understanding of this complex field, ensuring
            that it is accessible to a wider and more diverse audience.
          </p>
          <p className="mb-2">
            See more and access the game in{" "}
            <a href="../epfl/game">our game page</a>. We encourage you to take a
            look at the game page before downloading the game.
          </p>
          <p>
            For more convenience, access the game here in{" "}
            <a href="https://gitlab.igem.org/2023/software-tools/epfl">
              {" "}
              IGEM software Gitlab repository
            </a>
            .
            <br /> The Git repository contains the .godot file, all the files
            required to build the game, and a README guide that explains how to
            build and run the game using GODOT.
            <br />
            The README also offers insights into game design, code, and
            instructions on how to utilize the template effectively. This
            resource not only enables gameplay but also facilitates easy
            modifications for future IGEM teams. You can also access the PDF of
            the readme below for your convenience.
          </p>
          <p>
            <br />
            <details>
              <summary>
                <mark>
                  <b>PDF of the game</b>
                </mark>
              </summary>
              <object
                data="https://static.igem.wiki/teams/4888/wiki/game/readme.pdf"
                width="800"
                height="500"
                aria-label="Flask Clamp PDF Document"
              />
            </details>
          </p>
          <br />
          <p>
            Additionally, we are offering a link to the drive where you can
            access the app version of the game that we have provided for users:{" "}
            <a href="https://drive.google.com/drive/folders/1H-4W0A03qS9c02kNHEzeER4AwsEUCHcr?usp=drive_link">
              {" "}
              Bioquest Drive
            </a>
            .
          </p>
          <br />
          <center>
          <Link to="../epfl/game">
        <button
          style={{
            backgroundColor: '#e29aff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '50px', // Augmentez la marge à droite
          }}
        >
          GAME PAGE
        </button>
        </Link>
        </center>
        

        </div>
        <div>
          <h2 id="wiki" className="mt-20">
            Wiki
          </h2>
          <hr className="dividergeneral mb-5" />

          <p className="mb-2">
            Synthetic biology can be a complex subject, especially for those who
            aren't already familiar with the specific terminology used in
            biology. Understanding the basics of synthetic biology often
            involves learning specialized words and phrases that can be
            challenging for newcomers.
          </p>
          <p className="mb-2">
            To address this challenge and make synthetic biology more
            approachable, we have developed a user-friendly version of our wiki,
            accompanied by an interactive dictionary that explains the
            specialized terms commonly used in this field.
          </p>
          <p className="mb-2">
            This initiative aims to broaden the accessibility of our project,
            making it available to a wider audience. This audience includes high
            school and middle school students who may be just beginning to
            explore biology, as well as adults who have chosen career paths
            outside the realm of biology.
          </p>
          <div className="centered-image mb-20">
            <CarouselHP items={wiki} title="Our adapted wiki" />
          </div>
        </div>
      </div>
      <h2 id="eventsedu" className="mt-20">
        Events
      </h2>
      <hr className="dividergeneral" />
      <div>
        <h3 id="openday" className="mt-5 mb-5">
          Open days-booth
        </h3>
        <p className="mb-2">
          In the spring of 2023, EPFL (École Polytechnique Fédérale de Lausanne)
          welcomed more than 25,000 visitors over a span of two days. During
          this occasion, our team had the opportunity to host a booth, which
          enabled us to showcase the iGEM competition, synthetic biology, and
          our own project. This endeavor allowed us to engage with a variety of
          people of every age, ranging from primary school children to
          university students and beyond.
        </p>
        <p className="mb-2">
          To ensure that we could answer to the diversity of our public, we
          developed different activities to keep them engaged regardless of
          their age. For the youngest attendees, we created small games to
          convey the fundamental concepts of our project and synthetic biology.
          Through these activities, we sought to develop an interest in science
          in this younger audience following the spirit of the EPFL open days.
          For older students and adults, we had the opportunity to delve deeper
          into synthetic biology as well as engage in discussion with them,
          sharing our project’s objective, and methodologies. These interactions
          were intended to educate the broader public on synthetic biology and
          encourage other EPFL students to consider participating in iGEM in the
          future.
        </p>
        <p className="mb-2">
          Our participation in this event not only allowed us to share our
          passion for synthetic biology but also served as a platform to promote
          the iGEM competition and its educational opportunities. We aimed to
          create awareness about the significance of hands-on learning and
          research in the field of synthetic biology and inspire a new
          generation of scientists and engineers.
        </p>
        <p>
          The positive response from the visitors to this weekend of discovery
          reaffirmed the importance of science outreach and education. It
          showcased the value of making complex concepts accessible to any
          audience, sparking interest, and potentially shaping the future of
          STEM education and research.
        </p>
      </div>
      <div>
        <h3 id="gymvisit" className="mt-20 mb-5">
          Gymnase visit
        </h3>
        <p className="mb-2">
          In the month of June, we had the pleasure of hosting two separate
          groups, each consisting of 12 students, from nearby high schools. We
          initiated the meeting with a presentation which introduced the
          fundamental concepts of synthetic biology and provided an overview of
          our own project. To gauge their comprehension and reinforce their
          learning, we provided a brief quiz to the students following the
          presentation. This served as an opportunity for them to consolidate
          their understanding and test their knowledge. The feedback from the
          students was positive, and they expressed their appreciation for this
          interactive learning experience.
        </p>
        <p className="mb-2">
          We then started an open discussion with the students. This segment
          allowed them to ask any questions that they might have had during the
          presentation, seek further clarification on our project, and ask about
          our own academic experience. The students were keen to learn about the
          individual journeys that led our team members to become involved in
          synthetic biology. We were more than happy to share our personal
          experiences, insights, and motivations, hoping to encourage them to
          consider furthering their studies in engineering if not in synthetic
          biology.
        </p>
        <div className="centered-image">
          <CarouselHP items={gymvis} title="Gymnase visit" />
        </div>
      </div>
      <div>
        <h3 id="MINT" className="mt-20 mb-5">
          MINTeressiert die Welt!
        </h3>
        <p className="mb-2">
          Each year, the "MINTeressiert die Welt!" (MINTerest the World!) summer
          school program takes place at EPFL, with the goal of developing
          students' interest in a wide range of applications in the MINT field,
          which encompasses Mathematics, Computer Science, Natural Sciences, and
          Technology.
        </p>
        <p className="mb-2">
          During this enriching summer program, our team had the privilege of
          representing the Life Sciences faculty and engaging with a group of 16
          high school students from the Swiss-German region. Our primary
          objective was to introduce them to the world of synthetic biology.
        </p>
        <p className="mb-2">
          Our interaction with the students began with an introductory session
          in which we provided an overview of iGEM and the fundamental concepts
          of synthetic biology. We also took the opportunity to present our own
          project, focusing on its objectives and significance.
        </p>
        <p className="mb-2">
          To spark their interest and provide a hands-on experience, we delved
          into the protocols of a couple of synthetic biology experiments. The
          aim was to give the students a taste of the practical aspects of this
          field. Specifically, we explained the procedures involved in two
          experiments: DNA extraction from fruits and the expression of GFP
          (Green Fluorescent Protein) in Freeze-Dried Cell-Free systems.
        </p>
        <p className="mb-2">
          Subsequently, the students were given the opportunity to apply these
          experiments. This hands-on approach allowed them to not only witness
          but also engage in the scientific process.
        </p>
        <p className="mb-2">
          Throughout the event, we encouraged an open dialogue, and the students
          were encouraged to ask questions about the experiments, synthetic
          biology in general, or any related topics. By offering insights and
          addressing their inquiries, we aimed to deepen their understanding and
          inspire a lasting interest in the field of synthetic biology.
        </p>
        <div className="centered-image">
          <CarouselHP items={Mint} title="MINTeressiert die Welt!" />
        </div>
      </div>
      <div>
        <div className="mb-20">
          <h2 id="Institut" className="mt-20">
            Helping and encouraging the future of iGEM
          </h2>
          <hr className="dividergeneral mb-5" />
          <p>
            We had the chance to exchange with a teacher and his students from a
            local high school that wishes to participate in iGEM in 2024. We
            gladly answered any question that they may have about the
            competition and shared with them some of our educational
            initiatives, such as our video courses on synthetic biology to give
            them the beginning of an idea of what iGEM entails. They greatly
            appreciated the videos. On top of the videos, they also had the
            opportunity to try out our video game: BioQuest in exchange for
            their feeback which was positive.
          </p>
          <p>
            Our aim was to boost their enthusiasm and motivation for
            participating in iGEM 2024 through these interactions. We also hope
            that our initiatives, like BioQuest and our educational programs
            such as BSGV, will inspire other high schools to follow in their
            footsteps and get involved in the exciting world of synthetic
            biology and iGEM.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ArticleEducation;
